module.exports = __webpack_public_path__ + "img/portfolio-arrow-left.4e467e94.svg";